import { render, staticRenderFns } from "./cardTemplateVip32.vue?vue&type=template&id=051f3d3c&scoped=true&"
import script from "./cardTemplateVip32.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip32.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip32.vue?vue&type=style&index=0&id=051f3d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f3d3c",
  null
  
)

export default component.exports